import { useConcurso } from '../../../../../providers/ConcursoProvider';
import ConcursoPublicadoCG from './ConcursoPublicadoCG';

const TramitarComiteGeneral = () => {
  const concurso = useConcurso();
  const etapa = concurso.etapaLlamadoConcurso.idEtapaLlamadoConcurso;
  const numeroDeEtapa = (etapa) => {
    if (etapa > 5 && etapa <= 20) {
      return etapa;
    }
  };
  switch (etapa) {
    /*case 1:
      return <CargaConvocatoria concurso={concurso} />;
    case 2:
      return <CargaCoordConcur concurso={concurso} />;
    case 3:
      <DesignacionVeedores concurso={concurso} />;
      break;
    case 4:
      return <CargaDictamen concurso={concurso} />;
    case 5:
      return <PrimerActa />;
    case 6:
      return <CargaActoAdministrativo />;
    case 7:
      return <Publicar />;
      */
    case numeroDeEtapa(etapa):
      return <ConcursoPublicadoCG />;
    default:
      return <div>No posee permisos para operar en esta etápa</div>;
  }
};
export default TramitarComiteGeneral;
